import React, { useState, useEffect, useCallback } from "react";
import {
  Paper,
  Box,
  IconButton,
  Button,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputAdornment,
  TextField,
  Slider,
  CircularProgress,
  Autocomplete,
  Typography,
  Divider,
} from "@mui/material";
import Assetchart from "../Charts/Assetchart";
import CircleIcon from "@mui/icons-material/Circle";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import "../../Styles/strategy.css";
import { useFormik } from "formik";
import { strategyschema } from "../Schemas/strategydetails";
import {
  modifyStrategies,
  getCustodians,
  getCustodianAssets,
  normalizeCustodianName,
} from "../../Redux/Actions/strategyService";
import { useDispatch, useSelector } from "react-redux";
import customFailAlert from "../../Alerts/customFailAlert";
import customSuccessAlert from "../../Alerts/customSuccessAlert";
import { useNavigate, useParams } from "react-router-dom";
import ManagementTiersPopup from "../Popups/ManagementTiersPopup";

function MainEditStrategy() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [proportionError, setProportionError] = useState(false);
  const [valueData, setValueData] = useState([]);
  const [custData, setCustData] = useState([]);
  const [openTier, setOpenTier] = useState(false);
  const [managementFeesTier, setmanagementFeesTier] = useState([
    { id: 1, range: { min: "", max: "" }, percentage: "" },
  ]);
  const [tierError, setTierError] = useState("");
  const [assetError, setAssetError] = useState("");
  const [cashProportion, setCashProportion] = useState(0);
  const [investmentType, setInvestmentType] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingKey, setLoadingKey] = useState(null);
  const [mediaFile, setMediaFile] = useState(null);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [uploadedMediaUrl, setUploadedMediaUrl] = useState(null);
  const [checkOldMedia, setcheckOldMedia] = useState();

  const [hurdleRateApplicable, setHurdleRateApplicable] = useState("No");
  const [hurdleRateType, setHurdleRateType] = useState("");
  const [hurdleRateValue, setHurdleRateValue] = useState("");
  const [benchmark, setBenchmark] = useState("");
  const [hurdleRateError, setHurdleRateError] = useState(""); // New state for error message
  const [manageFeeError, setManageFeeError] = useState(""); // New state for management fee error
  const [perfFeeError, setPerfFeeError] = useState(""); // New state for performance fee error
  const [benchmarkComparison, setBenchmarkComparison] = useState("");

  const { Custodians, custodianAssets, strategies } = useSelector(
    (state) => state?.strategy
  );
  const userInfoString = localStorage.getItem("userInfo");
  const userInfo = userInfoString && userInfoString !== "undefined" ? JSON.parse(userInfoString) : null;
  const portal = userInfo?.portal || 'MANAGER';

  const [managementFeesTiers, setManagementFeesTiers] = useState([
    { limit: "", fee: "" }
  ]);

  const [previousAllocations, setPreviousAllocations] = useState({});

  const benchmarkOptions = {
    "^GSPC": "S&P 500",
    "^IXIC": "NASDAQ",
    "^DJI": "Dow Jones",
    "^RUT": "Russell 2000",
    "EEM": "MSCI Emerging",
    "^FTSE": "FTSE 100",
    "XLK": "Technology Select",
    "BND": "Vanguard Total Bond",
    "GC=F": "Gold Spot Price",
    "CL=F": "Crude Oil (WTI)"
  };

  const [isAddAssetClicked, setIsAddAssetClicked] = useState(false);

  const [loadingAssets, setLoadingAssets] = useState({});

  useEffect(() => {
    if (id && strategies) {
      const findStrategy = strategies.find((i) => i.id === id);
      if (findStrategy) {
        setFieldValue("name", findStrategy.name);
        setFieldValue("details", findStrategy.description);
        setFieldValue(
          "risklevel",
          findStrategy.riskLevel ? findStrategy.riskLevel.toUpperCase() : ""
        );
        setFieldValue("minvalue", findStrategy.minInvestment);
        setFieldValue("custodian", findStrategy?.custodian);
        setFieldValue("selectmang", findStrategy?.managementFeesFrequency);
        setFieldValue("selectperf", findStrategy?.performanceFeesFrequency);
        setFieldValue("manageper", findStrategy?.managementFeesTiers);
        setFieldValue("perfper", findStrategy?.performanceFeesPercentage);
        if(findStrategy?.managementFeesTiers.length == 1){
          setFieldValue("isFlatFee", "false");
        }
        else {
          setFieldValue("isFlatFee", "true");
        }

        const transformedTiers = findStrategy?.managementFeesTiers.map(
          (tier, index) => ({
            id: index + 1,
            range: { min: 0, max: tier.limit },
            percentage: tier.fee,
          })
        );

        setmanagementFeesTier(transformedTiers);

        const usdAllocation = findStrategy?.breakups?.find(
          (asset) => asset.asset.symbol === "USD"
        );
        if (usdAllocation) {
          setCashProportion(usdAllocation.proportion);
        }

        const nonUsdAssets = findStrategy?.breakups?.filter(
          (asset) => asset.asset.symbol !== "USD"
        );
        setValueData(nonUsdAssets || []);
        
        // Store previous allocations
        const allocations = {};
        nonUsdAssets?.forEach(asset => {
          allocations[asset.asset.symbol] = asset.proportion;
        });
        if (usdAllocation) {
          allocations['USD'] = usdAllocation.proportion;
        }
        setPreviousAllocations(allocations);
        
        dispatch(getCustodianAssets(findStrategy?.custodian));
        setInvestmentType(findStrategy.securityType || "STK");

        if (findStrategy.media) {
          setUploadedMediaUrl(findStrategy.media); // Set the uploaded media URL
        }
        if (findStrategy.hurdleRateType) {
          setHurdleRateApplicable("Yes");
        }
        setHurdleRateType(findStrategy.hurdleRateType || "");
        // Populate new fields from the existing strategy data if availablE
        if (findStrategy.hurdleRateType === "FIXED") {
          const initialValue = findStrategy.hurdleRatePercentage || "";
          setHurdleRateValue(initialValue);
          if (initialValue < 0 || initialValue > 100) {
            setHurdleRateError("Hurdle Rate must be between 0 and 100.");
          } else {
            setHurdleRateError(""); // Clear error if valid
          }
        }
        if (findStrategy.hurdleRateType === "BENCHMARK")
          setBenchmark(findStrategy.benchmarkType || "");

        if (findStrategy.benchmarkComparison) {
          setBenchmarkComparison(findStrategy.benchmarkComparison.symbol || "");
        }

        if (findStrategy.performanceBenchmark) {
          setBenchmark(findStrategy.performanceBenchmark.symbol);
        }

        if (findStrategy.managementFeesTiers && findStrategy.managementFeesTiers.length > 0) {
          setManagementFeesTiers(findStrategy.managementFeesTiers.map(tier => ({
            limit: tier.limit,
            fee: tier.fee
          })));
        }
      }
    }
  }, [id, strategies, dispatch]);

  useEffect(() => {
    if (custodianAssets) setCustData(custodianAssets);
    else setCustData([]);
  }, [custodianAssets]);

  useEffect(() => {
    dispatch(getCustodians());
  }, [dispatch]);

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      name: "",
      details: "",
      minvalue: 2,
      risklevel: "",
      isFlatFee: false,
      custodian: "",
      perfper: 0,
      manageper: 0,
      selectperf: "",
      selectmang: "",
      assetError: "",
      flatManagementFeePercentage: 0,
    },
    //  validationSchema: strategyschema,
    onSubmit: async (values) => {
      const totalProportions = valueData.reduce(
        (total, asset) => total + asset.proportion,
        cashProportion
      );
      if (totalProportions !== 100) {
        customFailAlert("Sum of all proportions must be 100%");
        return;
      }
  
      if (values.isFlatFee) {
        if (managementFeesTier.length === 0) {
          alert("Please add values in Management Fees Tier.");
          return;
        }
      } 
      const breakups = [
        ...valueData?.map(({ asset, ...rest }) => ({
          proportion: parseFloat(rest.proportion),
          asset: {
            symbol: asset.symbol,
            name: asset.name,
            ...(values.custodian === "IBKR" && asset.conId ? { conId: asset.conId } : {})
          }
        })),
      ];

      if (cashProportion > 0) {
        breakups.push({
          proportion: parseFloat(cashProportion),
          asset: {
            symbol: "USD",
            name: "United States Dollar"
          }
        });
      }

      const management = managementFeesTier?.map((row) => ({
        limit: parseFloat(row.range.max),
        fee: parseFloat(row.percentage),
      }));

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("description", values.details);
      let securityType;
      if (values.custodian === "IBKR" || values.custodian === "COINBASE" || values.custodian === "Charles Schwab" || values.custodian === "CHARLES SCHWAB") {
        securityType = investmentType || "CRYPTO";
      } else {
        securityType = "STK"; // Default to STK for other custodians
      }
      formData.append("securityType", securityType);
      formData.append("minInvestment", parseInt(values.minvalue)); // Ensure integer
      // Normalize custodian so backend always receives a valid enum value
      const normalizedCustodian = normalizeCustodianName(values.custodian);
      formData.append("custodian", normalizedCustodian);
      formData.append("riskLevel", values.risklevel);
      formData.append("managementFeesFrequency", values.selectmang);
      formData.append("performanceFeesFrequency", values.selectperf);
      // formData.append("managementFeesPercentage", parseFloat(values.manageper));
      formData.append("performanceFeesPercentage", parseFloat(values.perfper));
       management.forEach((tier, index) => {
          formData.append(`managementFeesTiers[${index}][limit]`, tier.limit);
          formData.append(`managementFeesTiers[${index}][fee]`, tier.fee);
        });
      

      if (hurdleRateApplicable === "yes")
        formData.append("hurdleRateType", hurdleRateType);
      if (hurdleRateType === "BENCHMARK") {
        const benchmarkName = {
          "^GSPC": "S&P 500",
          "^IXIC": "NASDAQ",
          "^DJI": "Dow Jones",
          "^RUT": "Russell 2000",
          "EEM": "MSCI Emerging",
          "^FTSE": "FTSE 100",
          "XLK": "Technology Select",
          "BND": "Vanguard Total Bond",
          "GC=F": "Gold Spot Price",
          "CL=F": "Crude Oil (WTI)"
        }[benchmark];

        formData.append("performanceBenchmark[name]", benchmarkName);
        formData.append("performanceBenchmark[symbol]", benchmark);
      }
      else formData.append("hurdleRatePercentage", hurdleRateValue);

      breakups.forEach((breakup, index) => {
        formData.append(`breakups[${index}][proportion]`, breakup.proportion);
        formData.append(`breakups[${index}][asset][symbol]`, breakup.asset.symbol);
        formData.append(`breakups[${index}][asset][name]`, breakup.asset.name);
        
        // Only append conId when custodian is IBKR and asset is not USD (cash)
        if (values.custodian === "IBKR" && breakup.asset.symbol !== "USD" && breakup.asset.conId) {
          formData.append(`breakups[${index}][asset][conId]`, breakup.asset.conId);
        }
      });

      if (benchmarkComparison) {
        formData.append("benchmarkComparison[symbol]", benchmarkComparison);
        formData.append("benchmarkComparison[name]", benchmarkOptions[benchmarkComparison]);
      }

      if (mediaFile) {
        formData.append("media", mediaFile);
        formData.append("oldMedia", false);
      } else if (uploadedMediaUrl) {
        formData.append("oldMedia", true);
      } else {
        formData.append("oldMedia", false);
      }
      setLoading(true); // Set loading to true when starting the API call
      await dispatch(modifyStrategies({ id: id, body: formData, role: portal }))
        .then((response) => {
          if (response?.payload.statusCode === 200) {
            customSuccessAlert("Strategy Updated Successfully.");
            navigate("/strategy");
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false); // Reset loading to false after the API call
        });
    },
  });

  function valuetext(value) {
    return `${value}%`;
  }

  const handleProportionChange = (symbol, newValue) => {
    if (symbol === "USD") {
      setCashProportion(newValue);
      checkTotalProportion(valueData, newValue);
    } else {
      const updatedValueData = valueData.map((item) =>
        item.asset?.symbol === symbol ? { ...item, proportion: newValue } : item
      );
      setValueData(updatedValueData);
      checkTotalProportion(updatedValueData, cashProportion);
    }
  };

  const handleCashProportionChange = (event, newValue) => {
    setCashProportion(newValue);
    checkTotalProportion(valueData, newValue);
  };

  const checkTotalProportion = (valueData, cashProportion) => {
    const totalProportions = valueData.reduce(
      (total, asset) => total + parseFloat(asset.proportion || 0),
      parseFloat(cashProportion || 0)
    );
    
    // Round to 2 decimal places
    const roundedTotal = Math.round(totalProportions * 100) / 100;
    setProportionError(roundedTotal !== 100);
  };

  const resetFunction = () => {
    setValueData([]);
    setCashProportion(0);
    setProportionError(false);
  };

  const AddList = () => {
    // Add new asset with 0 proportion - user will set manually
    const newAssetEntry = {
      asset: { symbol: "", name: "" },
      proportion: 0,
    };

    const updatedValueData = [...valueData, newAssetEntry];

    setValueData(updatedValueData);
    setIsAddAssetClicked(true);
    setProportionError(true); // Set error since total won't be 100 with new 0% asset
  };

  const handleRemoveAsset = (key) => {
    const updatedValueData = valueData.filter((item, index) => index !== key);
    
    setValueData(updatedValueData);

    // Recalculate total after removal - no redistribution
    const totalProportions = updatedValueData.reduce(
      (total, asset) => total + parseFloat(asset.proportion || 0),
      0
    );
    const total = totalProportions + cashProportion;
    if (total !== 100) {
      setProportionError(true);
    } else {
      setProportionError(false);
    }
  };

  const handleSearchChange = useCallback(
    (event, value, key) => {
      if (value) {
        setLoadingAssets((prev) => ({ ...prev, [key]: true }));
        if (searchTimeout) clearTimeout(searchTimeout);
        setSearchTimeout(
          setTimeout(() => {
            let currentInvestmentType;
            if (values.custodian === "IBKR" || values.custodian === "COINBASE" || values.custodian === "Charles Schwab" || values.custodian === "CHARLES SCHWAB") {
              currentInvestmentType = investmentType || "CRYPTO";
            } else {
              currentInvestmentType = "STK"; // Default to STK for other custodians
            }
            dispatch(
              getCustodianAssets({
                custodian: values.custodian,
                query: value,
                investmentType: currentInvestmentType,
                exchange: "NASDAQ",
              })
            )
              .then((response) => {
                if (response?.payload.statusCode === 200) {
                  const filteredResults = response?.payload.data.filter(
                    (asset) =>
                      !valueData.some(
                        (item) => item.asset?.symbol === asset.symbol
                      )
                  );
                  setSearchResults(filteredResults);
                }
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                setLoadingAssets((prev) => ({ ...prev, [key]: false }));
              });
          }, 2000)
        );
      }
    },
    [dispatch, investmentType, values.custodian, valueData, searchTimeout]
  );

  const handleAssetSelect = (event, newValue, key) => {
    if (newValue) {
      const isDuplicate = valueData.some(
        (item, index) => item.asset?.symbol === newValue.symbol && index !== key
      );

      if (isDuplicate) {
        setAssetError("Asset Already Added");
        return;
      }

      if (newValue.symbol === "USD") {
        setCashProportion(valueData[key]?.proportion || 0);
        const updatedValueData = valueData.filter((_, index) => index !== key);
        setValueData(updatedValueData);
      } else {
        const updatedValueData = valueData.map((item, index) =>
          index === key
            ? {
                ...item,
                asset: newValue,
                proportion: item.proportion,
              }
            : item
        );
        setValueData(updatedValueData);
        checkTotalProportion(updatedValueData, cashProportion);
      }
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (
      file &&
      (file.type === "video/mp4" || file.type === "video/x-matroska")
    ) {
      if (file.size <= 100 * 1024 * 1024) {
        setMediaFile(file);
        setUploadedMediaUrl(null);
      } else {
        customFailAlert("File size exceeds the 100MB limit.");
      }
    } else {
      customFailAlert(
        "Unsupported file format. Only .mp4 and .mkv files are allowed."
      );
    }
  };

  const handleRemoveFile = () => {
    setUploadedMediaUrl(null);
    setMediaFile(null);
    setcheckOldMedia(true);
  };

  const handleHurdleRateValueChange = (value) => {
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0) {
      setHurdleRateError("Hurdle Rate must be 0 or greater.");
      setHurdleRateValue("");
      return;
    }
    setHurdleRateError("");
    setHurdleRateValue(numericValue);
  };

  const handleManageFeeChange = (value) => {
    if (value === "") {
      setFieldValue("manageper", value);
      setManageFeeError("Management Fee is required.");
      return;
    }
    if (value === "." || value === "0.") {
      setFieldValue("manageper", value);
      setManageFeeError("");
      return;
    }
    
    // Check if it's a valid number format (allows decimals)
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0) {
      setManageFeeError("Management Fee must be 0 or greater.");
      // Still allow the value to be set so user can continue typing
      setFieldValue("manageper", value);
      return;
    }
    setManageFeeError("");
    setFieldValue("manageper", value); // Store as string to preserve decimals
  };

  const handlePerfFeeChange = (value) => {
    // Allow empty string and preserve decimal point while typing
    if (value === "" || value === "." || value === "0.") {
      setFieldValue("perfper", value);
      setPerfFeeError("");
      return;
    }
    
    // Check if it's a valid number format (allows decimals)
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0) {
      setPerfFeeError("Performance Fee must be 0 or greater.");
      // Still allow the value to be set so user can continue typing
      setFieldValue("perfper", value);
      return;
    }
    setPerfFeeError("");
    setFieldValue("perfper", value); // Store as string to preserve decimals
  };
  const isDisabled = () => {
    if (!values.custodian) return true;
    // For IBKR, Coinbase, and Charles Schwab, investment type must be selected
    if (values.custodian === "IBKR" || values.custodian === "COINBASE" || values.custodian === "Charles Schwab" || values.custodian === "CHARLES SCHWAB") {
      if (!investmentType) return true;
    }
    return false;
  };

  // const handleManagementFeesChange = (index, field, value) => {
  //   const newTiers = [...managementFeesTiers];
  //   newTiers[index][field] = value;
  //   setManagementFeesTiers(newTiers);
  // };

  const getPreviousAllocation = (symbol) => {
    return previousAllocations[symbol] || 0;
  };

  const handleDirectInputChange = (symbol, inputValue) => {
    // Convert input to number and limit to 0-100
    let newValue = Math.min(Math.max(Number(inputValue) || 0, 0), 100);
    
    // Calculate total allocation excluding the current symbol
    let totalOtherAllocations = 0;
    let updatedValueData = [...valueData]; // Create a copy of valueData

    if (symbol === "USD") {
      totalOtherAllocations = valueData.reduce((sum, item) => 
        sum + parseFloat(item.proportion || 0), 0);
    } else {
      totalOtherAllocations = valueData.reduce((sum, item) => 
        item.asset?.symbol === symbol ? sum : sum + parseFloat(item.proportion || 0), 0
      ) + parseFloat(cashProportion || 0);
    }

    // Ensure total doesn't exceed 100%
    if (totalOtherAllocations + newValue > 100) {
      newValue = 100 - totalOtherAllocations;
    }

    // Round to 2 decimal places to avoid floating point issues
    newValue = Math.round(newValue * 100) / 100;

    // Update the value
    if (symbol === "USD") {
      setCashProportion(newValue);
    } else {
      updatedValueData = valueData.map((item) =>
        item.asset?.symbol === symbol ? { ...item, proportion: newValue } : item
      );
      setValueData(updatedValueData);
    }

    // Use setTimeout to ensure state updates have propagated
    setTimeout(() => {
      if (symbol === "USD") {
        checkTotalProportion(valueData, newValue);
      } else {
        checkTotalProportion(updatedValueData, cashProportion);
      }
    }, 0);
  };

  const getAssetColor = (symbol) => {
    const colorMap = {
      BTC: '#9747FF',
      ETH: '#24B47E',
      SOL: '#F3BA2F',
      BNB: '#1E9BF0',
      // Add more as needed
    };
    return colorMap[symbol] || '#F3BA2F'; // Default color
  };

  return (
    <>
      <div className="row strategy-row">
        <div className="col-6">
          <Paper className="strategy-paper" >
            {/* Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3}}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontFamily: 'Founders Grotesk',
                  fontWeight: 500,
                  fontStyle: 'Medium',
                  fontSize: '24px',
                  lineHeight: '32px',
                  letterSpacing: '0%'
                }}
              >
                Strategy Details
              </Typography>
            </Box>
            <hr />
            <Box sx={{ width: "100%", typography: "body1" }}>
              <>
                <form className="strategy-form" onSubmit={handleSubmit}>
                  <div className="row mb-1">
                    <label
                      htmlFor="custodian"
                      className="col-sm-5 col-form-label form-label-bold"
                    >
                      Select Custodian
                    </label>
                    <div className="col-sm-7">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="custodian"
                          disabled
                          placeholder="Choose custodians"
                          value={values.custodian || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Select Custodian</option>
                          {Custodians?.map((i) => {
                            return (
                              <option key={i?.name} value={i?.name}>
                                {i?.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {errors.custodian && touched.custodian ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {errors.custodian}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {(values.custodian === "IBKR" || values.custodian === "COINBASE" || values.custodian === "Charles Schwab" || values.custodian === "CHARLES SCHWAB") && (
                    <>
                      <div className="row mb-1">
                        <label
                          htmlFor="investmentType"
                          className="col-sm-5 col-form-label"
                          style={{ fontWeight: "bold" }}
                        >
                          Select Investment Type
                        </label>
                        <div className="col-sm-7">
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="investment-type-label"
                              name="investmentType"
                              value={investmentType}
                              onChange={(e) =>
                                setInvestmentType(e.target.value)
                              }
                            >
                              <FormControlLabel
                                value="CRYPTO"
                                disabled={values.custodian === "IBKR" || values.custodian === "Charles Schwab" || values.custodian === "CHARLES SCHWAB"}
                                control={<Radio />}
                                label="Crypto"
                              />
                              <FormControlLabel
                                value="STK"
                                control={<Radio />}
                                label="Stock"
                                disabled={values.custodian === "COINBASE"}
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="row mb-3">
                    <label
                      htmlFor="name"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Name
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.name && touched.name ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {errors.name}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label
                      htmlFor="minvalue"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Minimum Value
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="number"
                        className="form-control"
                        name="minvalue"
                        value={values.minvalue}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.minvalue && touched.minvalue ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {errors.minvalue}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label
                      htmlFor="details"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Aim & Objectives
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        name="details"
                        value={values.details}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.details && touched.details ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {errors.details}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label
                      htmlFor="media"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Upload Media
                    </label>
                    <div className="col-sm-7">
                      {/* File Input */}
                      <input
                        type="file"
                        className="form-control"
                        accept=".mp4,.mkv"
                        onChange={handleFileChange}
                      />

                      {/* If media already exists, show the file download link */}
                      {uploadedMediaUrl && (
                        <div style={{ marginTop: "10px" }}>
                          {/* Download link for the existing media */}
                          <a
                            href={uploadedMediaUrl}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download current file
                          </a>
                          {/* Button to remove the file */}
                          <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleRemoveFile}
                            style={{ marginLeft: "10px" }}
                          >
                            Remove File
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label
                      htmlFor="benchmarkComparison"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Benchmark (Strategy)
                    </label>
                    <div className="col-sm-7">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="benchmarkComparison"
                          value={benchmarkComparison}
                          onChange={(e) => setBenchmarkComparison(e.target.value)}
                        >
                          <option value="">Select Benchmark</option>
                          {Object.entries(benchmarkOptions).map(([symbol, name]) => (
                            <option key={symbol} value={symbol}>
                              {name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label
                      htmlFor="risklevel"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Risk Level
                    </label>
                    <div className="col-sm-7 d-flex align-items-center">
                      <FormControl
                        component="fieldset"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="risklevel"
                          value={values.risklevel}
                          onChange={(e) =>
                            setFieldValue("risklevel", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="LOW"
                            control={<Radio />}
                            label="Low"
                            sx={{ marginRight: "6px" }}
                          />
                          <FormControlLabel
                            value="MEDIUM"
                            control={<Radio />}
                            label="Medium"
                            sx={{ marginRight: "6px" }}
                          />
                          <FormControlLabel
                            value="HIGH"
                            control={<Radio />}
                            label="High"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  
                  <div className="row mb-3">
                    <label
                      htmlFor="risklevel"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Managment Fee Tiers
                    </label>
                    <div className="col-sm-7 d-flex align-items-center">
                      <FormControl
                        component="fieldset"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="isFlatFee"
                          value={values.isFlatFee}
                          onChange={(e) =>
                            setFieldValue(
                              "isFlatFee",
                              e.target.value === "true"
                            )
                          }
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Yes"
                            sx={{ marginRight: "20px" }}
                            disabled={isDisabled()}
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="No"
                            sx={{ marginRight: "20px" }}
                            disabled={isDisabled()}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
        
                  <div className="row mb-1">
                    <label
                      htmlFor="management"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Management Fees
                    </label>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="management"
                          placeholder="Choose Frequency"
                          value={values.selectmang || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setFieldValue("selectmang", selectedValue);
                            if (selectedValue === "") {
                              setProportionError("");
                            }
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          style={{ width: "199px" }}
                        >
                          <option value="">Select Frequency</option>
                          {[
                            "MONTHLY",
                            "QUARTERLY",
                            "SEMI_ANNUALLY",
                            "ANNUALLY",
                          ].map((i) => (
                            <option key={i} value={i}>
                              {i}
                            </option>
                          ))}
                        </select>
                      </div>
                      {errors.selectmang && touched.selectmang ? (
                        <p className="form-error" style={{ color: "red", fontSize: "11px" }}>
                          {errors.selectmang}
                        </p>
                      ) : null}
                    </div>

                    {values.isFlatFee ? ( // If isFlatFee is true
                      <div style={{ marginLeft:"20px" }}>
                        <Button
                          variant="contained"
                          sx={{ mb: 1 }}
                          onClick={() => {
                            setOpenTier(true);
                          }}
                        >
                          Save Tiers
                        </Button>
                      </div>
                    ) : ( // If isFlatFee is false
                      <div className="col-sm-2">
                        <TextField
                          type="number"
                          name="manageper"
                          value={values.manageper !== undefined && values.manageper !== null ? String(values.manageper) : ""}
                          onChange={(e) => handleManageFeeChange(e.target.value)}
                          onBlur={handleBlur}
                          className="form-control no-spinners"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end"><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>
                            ),
                          }}
                          inputProps={{
                            min: 0,
                            step: "any"
                          }}
                          sx={{
                            height: "40px",
                            width: "120px",
                            ".MuiInputBase-input": {
                              height: "40px",
                              padding: "0 14px",
                            },
                          }}
                        />
                        {manageFeeError && ( // Display error message for management fee
                          <p style={{ color: "red", fontSize: "11px" }}>
                            {manageFeeError}
                          </p>
                        )}
                      </div>
                    )}
                  </div>

            
                  <div className="row mb-1">
                    <label
                      htmlFor="performance"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Performance Fees
                    </label>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="performance"
                          placeholder="Choose performance"
                          value={values.selectperf || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            if (selectedValue === "") {
                              setFieldValue("selectperf", "");
                              setProportionError("");
                            } else {
                              setFieldValue("selectperf", selectedValue);
                            }
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          style={{ width: "150px" }}
                        >
                          <option value="">Select Frequency</option>
                          {[
                            "MONTHLY",
                            "QUARTERLY",
                            "SEMI_ANNUALLY",
                            "ANNUALLY",
                          ].map((i) => {
                            return (
                              <option key={i} value={i}>
                                {i}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {errors.selectperf && touched.selectperf ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {errors.selectperf}
                        </p>
                      ) : null}
                    </div>
                    <div className="col-sm-2">
                      <TextField
                        type="number"
                        name="perfper"
                        value={values.perfper !== undefined && values.perfper !== null ? String(values.perfper) : ""}
                        onChange={(e) => handlePerfFeeChange(e.target.value)}
                        onBlur={handleBlur}
                        className="form-control"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end"><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>
                          ),
                        }}
                        inputProps={{
                          min: 0,
                          step: "any"
                        }}
                        sx={{
                          height: "40px",
                          width: "90px",
                          ".MuiInputBase-input": {
                            height: "40px",
                            padding: "0 14px",
                          },
                        }}
                      />
                      {perfFeeError && ( // Display error message for performance fee
                        <p style={{ color: "red", fontSize: "11px" }}>
                          {perfFeeError}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* Hurdle Rate Applicable Field */}
                  <div className="row mb-3">
                    <label
                      htmlFor="hurdleRateApplicable"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Hurdle Rate Applicable
                    </label>
                    <div className="col-sm-7">
                      <FormControl fullWidth>
                        <select
                          className="form-control"
                          id="hurdleRateApplicable"
                          value={hurdleRateApplicable}
                          onChange={(e) =>
                            setHurdleRateApplicable(e.target.value)
                          }
                        >
                          <option value="No">No</option>
                          <option value="Yes">Yes</option>
                        </select>
                      </FormControl>
                    </div>
                  </div>

                  {/* Conditionally show Hurdle Rate Type and Benchmark */}
                  {hurdleRateApplicable === "Yes" && (
                    <>
                      <div className="row mb-3">
                        <label
                          htmlFor="hurdleRateType"
                          className="col-sm-5 col-form-label"
                          style={{ fontWeight: "bold" }}
                        >
                          Hurdle Rate Type
                        </label>
                        <div className="col-sm-7">
                          <FormControl fullWidth>
                            <select
                              className="form-control"
                              id="hurdleRateType"
                              value={hurdleRateType}
                              onChange={(e) =>
                                setHurdleRateType(e.target.value)
                              }
                            >
                              <option value="">Select Type</option>
                              <option value="FIXED">Fixed</option>
                              <option value="BENCHMARK">Benchmark</option>
                            </select>
                          </FormControl>
                        </div>
                      </div>

                      {/* Conditionally show Hurdle Rate Value or Benchmark selection */}
                      {hurdleRateType === "FIXED" && (
                        <div className="row mb-3">
                          <label
                            htmlFor="hurdleRateValue"
                            className="col-sm-5 col-form-label"
                            style={{ fontWeight: "bold" }}
                          >
                            Hurdle Rate Value (%)
                          </label>
                          <div className="col-sm-7">
                            <TextField
                              type="number"
                              className="form-control no-spinners"
                              id="hurdleRateValue"
                              value={hurdleRateValue}
                              onChange={(e) =>
                                handleHurdleRateValueChange(e.target.value)
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span style={{fontWeight: 'bold'}}>%</span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{
                                min: 0,
                                step: "any"
                              }}
                              sx={{
                                height: "40px",
                                
                                ".MuiInputBase-input": {
                                  height: "40px",
                                  padding: "0 14px",
                                },
                              }}
                            />
                            {hurdleRateError && ( // Display error message
                              <p style={{ color: "red", fontSize: "11px" }}>
                                {hurdleRateError}
                              </p>
                            )}
                          </div>
                        </div>
                      )}

                      {hurdleRateType === "BENCHMARK" && (
                        <div className="row mb-3">
                          <label
                            htmlFor="benchmark"
                            className="col-sm-5 col-form-label"
                            style={{ fontWeight: "bold" }}
                          >
                            Benchmark (P. Fee)
                          </label>
                          <div className="col-sm-7">
                            <FormControl fullWidth>
                              <select
                                className="form-control"
                                id="benchmark"
                                value={benchmark}
                                onChange={(e) => setBenchmark(e.target.value)}
                              >
                                <option value="">Select Benchmark</option>
                                <option value="^GSPC">S&P 500</option>
                                <option value="^IXIC">NASDAQ</option>
                                <option value="^DJI">Dow Jones</option>
                                <option value="^RUT">Russell 2000</option>
                                <option value="EEM">MSCI Emerging</option>
                                <option value="^FTSE">FTSE 100</option>
                                <option value="XLK">Technology Select</option>
                                <option value="BND">Vanguard Total Bond</option>
                                <option value="GC=F">Gold Spot Price</option>
                                <option value="CL=F">Crude Oil (WTI)</option>
                              </select>
                            </FormControl>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  <div
                    className="row"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "10px",
                    }}
                  >
                    <Button 
                      type="submit" 
                      variant="contained"
                      sx={{ mb: 1, mr:1.5, pt:1,pb:1 }}
                    >
                      Save Strategy
                    </Button>
                  </div>
                </form>
                <br />
              </>
            </Box>
          </Paper>
        </div>

        {/* Right column for Asset Allocation */}
        <div className="col-6">
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)' }}>
            {/* Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3}}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontFamily: 'Founders Grotesk',
                  fontWeight: 500,
                  fontStyle: 'Medium',
                  fontSize: '24px',
                  lineHeight: '32px',
                  letterSpacing: '0%'
                }}
              >
                Asset Allocation
              </Typography>
              <Button
                className="reset-changes-button"
                onClick={resetFunction}
              >
                Reset Changes
              </Button>
            </Box>

            {/* Chart */}
            <Box sx={{ width: "100%", mb: 4 }}>
              <Assetchart 
                data={[
                  ...valueData.map(item => ({
                    ...item,
                    assetId: item.asset?.symbol || item.asset?.name || 'unknown'
                  })),
                  ...(cashProportion > 0 ? [{
                    asset: { name: "USD Cash", symbol: "USD" },
                    proportion: cashProportion,
                    assetId: "USD"
                  }] : [])
                ]} 
              />
            </Box>

            {/* Asset List */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* USD/Cash Row */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <CircleIcon sx={{ color: '#F3BA2F', fontSize: 36 }} />
                <Box sx={{ width: '90px', display: 'flex', flexDirection: 'column' }}>
                  <Typography className="asset-label-text">Cash</Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(USD)</Typography>
                </Box>
                <TextField
                  value={getPreviousAllocation('USD')}
                  disabled
                  size="small"
                  InputProps={{
                    endAdornment: <InputAdornment position="end" sx={{color: '#323232' }}>%</InputAdornment>,
                    sx: { 
                      fontSize: '0.875rem',
                      '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                      width: '90px',
                      backgroundColor: '#f5f5f5',
                      '& .Mui-disabled': {
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                      }
                    }
                  }}
                />
                <Slider
                  value={cashProportion}
                  onChange={(e, newValue) => handleCashProportionChange(e, newValue)}
                  sx={{ 
                    flex: 1,
                    '& .MuiSlider-rail': { backgroundColor: '#E0E0E0' },
                    '& .MuiSlider-track': { backgroundColor: '#1976d2' },
                    '& .MuiSlider-thumb': {
                      width: 12,
                      height: 12,
                      backgroundColor: '#fff',
                      border: '2px solid #1976d2',
                      '&:hover, &.Mui-focusVisible': {
                        boxShadow: 'none'
                      }
                    }
                  }}
                />
                <TextField
                  value={cashProportion}
                  onChange={(e) => handleDirectInputChange("USD", e.target.value)}
                  size="small"
                  InputProps={{
                    endAdornment: <InputAdornment position="end" sx={{color: '#323232' }}><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>,
                    sx: { 
                      fontSize: '0.875rem',
                      '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                      width: '90px'
                    }
                  }}
                />
                <Box sx={{ width: 25 }} /> {/* Maintain alignment */}
              </Box>

              <Divider/>

              {/* Other Assets */}
              {valueData.map((value, key) => (
                <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <CircleIcon sx={{ color: getAssetColor(value.asset.symbol), fontSize: 36 }} />
                  <Typography className="asset-label-text" sx={{ width: '90px' }}>
                    {value.asset.symbol || (
                      <Autocomplete
                        options={searchResults}
                        getOptionLabel={(option) => option.name || ""}
                        onInputChange={(event, newInputValue) => handleSearchChange(event, newInputValue, key)}
                        onChange={(event, newValue) => handleAssetSelect(event, newValue, key)}
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            label="Asset" 
                            sx={{ width: '100px' }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingAssets[key] ? <CircularProgress size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    )}
                  </Typography>
                  {value.asset.symbol && (
                    <TextField
                      value={getPreviousAllocation(value.asset.symbol)}
                      disabled
                      size="small"
                      InputProps={{
                        endAdornment: <InputAdornment position="end" sx={{color: '#323232' }}>%</InputAdornment>,
                        sx: { 
                          fontSize: '0.875rem',
                          '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                          width: '90px',
                          backgroundColor: '#f5f5f5',
                          '& .Mui-disabled': {
                            WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                          }
                        }
                      }}
                    />
                  )}
                  <Slider
                    value={value.proportion}
                    onChange={(e, newValue) => handleProportionChange(value.asset?.symbol, newValue)}
                    sx={{ 
                      flex: 1,
                      width: isAddAssetClicked ? 150 : 'auto',
                      '& .MuiSlider-rail': { backgroundColor: '#E0E0E0' },
                      '& .MuiSlider-track': { backgroundColor: '#1976d2' },
                      '& .MuiSlider-thumb': {
                        width: 12,
                        height: 12,
                        backgroundColor: '#fff',
                        border: '2px solid #1976d2',
                        '&:hover, &.Mui-focusVisible': {
                          boxShadow: 'none'
                        }
                      }
                    }}
                  />
                  <TextField
                    value={value.proportion}
                    onChange={(e) => handleDirectInputChange(value.asset?.symbol, e.target.value)}
                    size="small"
                    InputProps={{
                      endAdornment: <InputAdornment position="end" sx={{color: '#323232', fontFamily:'inherit' }}><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>,
                      sx: { 
                        fontSize: '0.875rem',
                        '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                        width: '90px'
                      }
                    }}
                  />
                  <IconButton 
                    size="small"
                    onClick={() => handleRemoveAsset(key)}
                    sx={{ 
                      padding: 0.5,
                      '&:hover': { backgroundColor: 'transparent' }
                    }}
                  >
                    <DeleteOutlineIcon sx={{ 
                      fontSize: 18, 
                      color: '#323232',
                      strokeWidth: 1.5,
                      '& path': {
                        strokeWidth: 1.5
                      }
                    }} />
                  </IconButton>
                </Box>
              ))}
            </Box>

            {/* Add Asset Button */}
            <Button
              sx={{ 
                mt: 3,
                width: 132,
                gap: 8,
                border: '2px solid #1976d2',
                color: '#1976d2',
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  backgroundColor: '#1976d2',
                  color: '#fff',
                },
                '&:disabled': {
                  border: '2px solid #ccc',
                  color: '#999',
                  backgroundColor: 'transparent',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: '#999',
                  }
                }
              }}
              onClick={AddList}
            >
              + Add Asset
            </Button>

            {proportionError && (
              <Typography color="error" sx={{ mt: 2, fontSize: '0.875rem' }}>
                Sum of all proportions must be 100%. Current total: {valueData.reduce((total, asset) => total + parseFloat(asset.proportion || 0), cashProportion)}%
              </Typography>
            )}
          </Paper>
        </div>
      </div>

      {loading && (
        <Box className="loading-overlay">
          <CircularProgress />
        </Box>
      )}
      <ManagementTiersPopup
        open={openTier}
        onClose={() => setOpenTier(false)}
        managementFeesTier={managementFeesTier}
        setmanagementFeesTier={setmanagementFeesTier}
      />
    </>
  );
}

export default MainEditStrategy;